import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step10 } from '../../../../../shared/models/component-messages/mapaIN/step10';
import { CTRL_410 } from '../../../../validators/410/ctrl410';
import { CTRL_411_def } from '../../../../validators/411/ctrl411_def';
import { CTRL_416 } from '../../../../validators/416/ctrl416';
import { CTRL_418 } from '../../../../validators/418/ctrl418';
import { CTRL_72 } from '../../../../validators/72/ctrl72';
import { CTRL_73 } from '../../../../validators/73/ctrl73';
import { CTRL_77 } from '../../../../validators/77/ctrl77';
import { TypeDelais } from '../../models/TypeDelais';
import { MapaINControlNames } from '../../service/mapaINControleNames';
import { CTRL_432 } from '../../../../validators/432/ctrl432';
import { CTRL_431 } from '../../../../validators/431/ctrl431';
@Component({
  selector: 'app-type-delais',
  templateUrl: './type-delais.component.html'
})
export class TypeDelaisComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeDelais';
  @Input() parentForm: FormGroup;
  @Input() delais: TypeDelais;
  @Input() disabled: boolean;



  public rg1 = CTRL_418.id + '_1';
  public rg2 = CTRL_431.id + '_2';
  public rg3 = CTRL_432.id + '_3';
  public rg4 = CTRL_77.id + '_1';
  public rg5 = CTRL_410.id + '_1';
  public rg6 = CTRL_411_def.id + '_1';
  public rg7 = CTRL_73.id + '_1';
  public rg8 = CTRL_416.id + '_2';
  public rg9 = CTRL_72.id + '_1';

  public step10 = new Step10();

  constructor() { }

  public ngOnInit() {
    this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_418Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg2, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_431Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg3, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_432Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg4, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_77Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg5, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_410Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg6, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_411Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg7, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_73Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg8, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_416Names_json() }));
    this.parentForm.addControl(this.getStepId() + this.rg9, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_72Names_json() }));
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }

}

